<template>
    <div class="recharge">
        <nav-bar></nav-bar>
        <div :class="isMobile ? 'm-content' : 'content'">
            <div class="box">
                <div class="box-left" v-if="!isMobile">
                    <p class="title">{{ $t('充值') }}</p>
                    <p class="int">{{ $t('温馨提示：请联系在线客服获取最新充值地址') }}</p>
                </div>
                <div class="box-right">
                    <div class="box-card">
                        <div class="card-top">
                            <div class="left">
                                <p>{{ $t('账户余额') }}</p>
                                <span>USD{{ $t('账户余额') }}</span>
                            </div>
                            <el-button  v-if="!isMobile" style="width: 180px;" @click="$router.push('/service')">{{ $t('充值') }}</el-button>
                        </div>
                        <P v-if="!isMobile">{{ $t('温馨提示：请联系在线客服获取最新充值地址') }}</P>
                    </div>
                    <div class="btn" v-if="isMobile">
                        <el-button round style="background-color: #000;color: #fff;width: 100%;padding: 15px 0;" @click="$router.push('/service')">{{ $t('充值') }}</el-button>
                    </div>
                    <el-button v-if="!isMobile" style="width: 120px;background-color: #1e4de7;color: #fff;border-radius: 6px;margin: 20px 0;">{{ $t('充值') }}</el-button>
                    <p v-else style="margin-bottom: 20px;">{{ $t('充值历史') }}</p>
                    <div class="list-item" v-for="(item,index) in list" :key="index">
                        <div class="list-top" v-if="!isMobile">
                            <span>{{ item.oid }}</span>
                            <p>{{ $t('订单号') }}</p>
                        </div>
                        <div class="list-top" v-if="isMobile">
                            <span>{{ item.oid }}</span>
                            <p>{{ $t('订单号') }}</p>
                        </div>
                        <div class="list-top">
                            <span>+ {{ item.num }}</span>
                            <!-- <span>{{ $t('订单金额') }}</span> -->
                        </div>
                        <div class="list-top" v-if="isMobile">
                            <span>{{ $t('成功') }}</span>
                            <!-- <span>{{ $t('订单状态') }}</span> -->
                        </div>
                        <div class="success" v-if="!isMobile">{{ $t('成功') }}</div>
                    </div>
                    <div class="empty" v-if="list.length == 0">
                        <img src="../../assets/img/empty.png" />
                    </div>
                </div>
            </div>
        </div>
        <footers v-if="!isMobile"></footers>
    </div>
</template>

<script>
import { caiwu  } from '../../api/index'
import formDate from '../../utils/formDate'
import { mapGetters } from "vuex";
    export default {
        data() {
            return {
                list: []
            }
        },
        computed: {
            ...mapGetters("device", ["isMobile"]),
        },
        created() {
            this.getList()
        },
        methods: {
            getList() {
                caiwu({page:1,size:10,type:1}).then(res=> {
                    if (res.code == 0) {
                        var result = res.data.list
                        result.forEach(el => {
                            el.addtime = formDate.getYMDHMS(el.addtime * 1000)
                        })
                        this.list = result
                        console.log('list', this.list)
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .recharge {

        .content {
            background: #f8f8f8;
            background-image: linear-gradient(-225deg, #2cd8d5, #c5c1ff 56%, #ffbac3);
            background-position: 0;
            background-size: cover;
            display: flex;
            justify-content: center;
            min-height: 100vh;
            width: 100%;

            .box {
                width: 72%;
                margin: 20px auto 60px auto;
                display: flex;
                padding-top: 90px;

                .box-left {
                    flex: 1;

                    .title {
                        font-size: 36px;
                        color: #fff;
                        font-weight: 800;
                    }

                    .int {
                        font-size: 16px;
                        color: #fff;
                    }
                }

                .box-right {
                    flex: 1;
                    background-color: #fff;
                    border-radius: 9px;
                    padding: 30px;
                    height: 600px;
                    overflow-y: scroll;
                    scrollbar-width: none;

                    ::-webkit-scrollbar {
                        display: none;
                    }

                    .box-card {
                        padding: 10px 20px;
                        background-color: #1e4de7;
                        font-size: 14px;
                        color: #fff;
                        border-radius: 12px;

                        .card-top {
                            display: flex;
                            justify-content: space-between;
                            align-items: center;

                            p {
                                font-size: 18px;
                                color: #c8c8c8;
                            }

                            span {
                                font-size: 28px;
                                color: #fff;
                            }
                        }
                    }

                    .list-item {
                        border-radius: 8px;
                        box-shadow: 0 2px 8px 0 rgba(99, 99, 99, .2);
                        box-sizing: border-box;
                        margin-bottom: 20px;
                        min-height: 100px;
                        padding: 3%;
                        width: 100%;

                        .list-top {
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            color: #000;
                        }

                        .success {
                            text-align: center;
                            color: #fff;
                            background-color: #1e4de7;
                            float: right;
                            padding: 5px 20px;
                            font-size: 14px;
                        }
                        &::after {
                            content: "";
                            display: table;
                            clear: both;
                        }
                    }
                }
            }

        }

        .m-content {

            .empty {
                width: 100%;
                img {
                    width: 100%;
                }
            }
            .box {
                width: 100%;
                display: flex;
                padding-top: 20px;

                .box-right {
                    flex: 1;
                    background-color: #fff;
                    border-radius: 9px;
                    padding: 10px;

                    .box-card {
                        padding: 10px 15px 30px 15px;
                        background-color: #1e4de7;
                        font-size: 14px;
                        color: #fff;
                        border-radius: 12px;

                        .card-top {
                            display: flex;
                            justify-content: space-between;
                            align-items: center;

                            p {
                                font-size: 14px;
                                color: #c8c8c8;
                            }

                            span {
                                font-size: 16px;
                                color: #fff;
                            }
                        }
                    }

                    .btn {
                        margin: 20px 0;
                    }

                    .list-item {
                        border-radius: 8px;
                        box-shadow: 0 2px 8px 0 rgba(99, 99, 99, .2);
                        box-sizing: border-box;
                        padding: 10px;
                        display: flex;
                        justify-content: space-between;
                        margin-bottom: 15px;

                        .list-top {
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            color: #000;

                            p {
                                font-size: 12px;
                                color: #333;
                            }

                            span {
                                font-size: 16px;
                                font-weight: 600;
                            }
                        }

                        .success {
                            text-align: center;
                            color: #fff;
                            background-color: #1e4de7;
                            float: right;
                            margin-top: 20px;
                            padding: 5px 20px;
                            font-size: 14px;
                        }
                    }
                }
            }
        }
    }
</style>
